/* eslint-disable */
export default {
  copyToClipboard: 'Kopiëren naar klembord',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
